module.exports = __webpack_public_path__ + "img/13.82484624.jpg";